import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Journal-Thin.otf%22,%22weight%22:%22100%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Journal-Light.otf%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Journal-.otf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Ivy-Presto-font-Family/fonnts.com-Ivy-Journal-Semi-Bold.otf%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22variable%22:%22--font-ivy-journal%22}],%22variableName%22:%22ivyJournal%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ivyJournal', 'ivyJournal Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
